<div class="staff-chat-wrapper">
  <!-- ===== LEFT PANEL ===== -->
  <aside class="staff-chat-sidebar">
    <!-- Search / New chat header -->
    <div class="sidebar-header">
      <h5 class="sidebar-title"><i class="bi bi-chat-dots-fill me-2 text-primary"></i>Team Chat</h5>
      <button class="btn btn-sm btn-primary rounded-circle" title="New Chat"
        (click)="showColleaguesList = !showColleaguesList">
        <i class="bi bi-pencil-square"></i>
      </button>
    </div>

    <!-- Colleagues panel (new chat) -->
    @if (showColleaguesList) {
    <div class="colleagues-panel">
      <p class="panel-section-label">Start a chat with a colleague</p>
      @if (colleaguesLoading) {
      <div class="text-center py-3">
        <div class="spinner-border spinner-border-sm text-primary"></div>
      </div>
      } @else if (colleagues.length === 0) {
      <p class="text-muted small px-3">No colleagues found in your practice.</p>
      } @else {
      <ul class="colleague-list">
        @for (c of colleagues; track c.id) {
        <li class="colleague-item" (click)="startChatWith(c)">
          <div class="chat-avatar chat-avatar--sm">{{ getInitials(c) }}</div>
          <div class="colleague-info">
            <span class="colleague-name">{{ c.firstName }} {{ c.lastName }}</span>
            <span class="colleague-role">{{ getRoleLabel(c.role) }}</span>
          </div>
        </li>
        }
      </ul>
      }
    </div>
    }

    <!-- Conversation list -->
    <div class="conversation-list">
      @if (conversations.length === 0) {
      <div class="empty-sidebar">
        <i class="bi bi-chat-left-dots fs-2 text-muted mb-2"></i>
        <p class="text-muted small">
          No conversations yet.<br />Click <strong>✎</strong> to start one.
        </p>
      </div>
      }
      @for (conv of conversations; track conv.id) {
      <div class="conversation-item" [class.active]="activeConversation?.id === conv.id"
        (click)="openConversation(conv)">
        <div class="chat-avatar">{{ getInitials(conv) }}</div>
        <div class="conversation-info">
          <span class="conv-name">{{ conv.title }}</span>
          @if (conv.lastMessage) {
          <span class="conv-preview">{{ conv.lastMessage }}</span>
          }
        </div>
        @if (conv.unreadCount > 0) {
        <span class="unread-badge">{{ conv.unreadCount }}</span>
        }
      </div>
      }
    </div>
  </aside>

  <!-- ===== RIGHT PANEL ===== -->
  <main class="staff-chat-main">
    @if (!activeConversation) {
    <div class="chat-empty-state">
      <i class="bi bi-chat-quote-fill fs-1 text-primary opacity-50 mb-3"></i>
      <h5 class="text-muted">Select a conversation or start a new one</h5>
      <p class="text-muted small">Messages are end-to-end within your practice.</p>
    </div>
    } @else {
    <!-- Chat header -->
    <div class="chat-header">
      <div class="chat-avatar">{{ getInitials(activeConversation) }}</div>
      <div>
        <div class="fw-semibold">{{ activeConversation.title }}</div>
        <small class="text-success d-flex align-items-center gap-1">
          <i class="bi bi-circle-fill" style="font-size: 0.45rem"></i> Practice Staff
        </small>
      </div>
    </div>

    <!-- Messages area -->
    <div class="chat-messages-area" #messageContainer>
      @if (messagesLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary"></div>
      </div>
      } @else if (messages.length === 0) {
      <div class="chat-empty-messages">
        <i class="bi bi-chat-heart fs-2 text-primary mb-2"></i>
        <p class="text-muted small">Start the conversation!</p>
      </div>
      } @else {
      @for (msg of messages; track msg.id) {
      <div class="chat-bubble-row" [class.me]="isMe(msg)">
        <div class="chat-bubble" [class.bubble-me]="isMe(msg)" [class.bubble-other]="!isMe(msg)">
          <div class="bubble-text">{{ msg.content }}</div>
          @if (msg.sentTime) {
          <div class="bubble-time">{{ msg.sentTime | date: 'HH:mm' }}</div>
          }
        </div>
      </div>
      }
      }
    </div>

    <!-- Typing indicator -->
    @if (isPartnerTyping) {
    <div class="typing-indicator px-4 py-1 text-muted small fst-italic fade-in">
      {{ partnerTypingName }} is typing...
    </div>
    }

    <!-- Input area -->
    <div class="chat-input-area">
      <textarea class="form-control chat-input" rows="1" placeholder="Type a message..." [(ngModel)]="newMessage"
        (input)="onInput()" (keydown)="onEnter($event)"></textarea>
      <button class="btn btn-primary send-btn" (click)="sendMessage()" [disabled]="!newMessage.trim()">
        <i class="bi bi-send-fill"></i>
      </button>
    </div>
    }
  </main>
</div>